import { AppInjector } from '../services/app-injector.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { BaseHttpService } from '../services/base-http.service';
import { RoutesPath } from '../routes-path';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { OnDestroy, Directive } from '@angular/core';
import { Config } from '@shared/config';
import { LanguageService } from '@shared/services/language.service';
import { DatetimeService } from '@shared/services/datetime.service';

@Directive()
export class BaseComponent implements OnDestroy {
  router: Router;
  storage: StorageService;
  toast: ToastrService;
  baseHttp: BaseHttpService;
  RoutesPath: any = RoutesPath;
  translate: TranslateService;
  languageService: LanguageService;
  someSubscriptions: Subscription = new Subscription();
  Config: any = Config;
  route: ActivatedRoute;
  datetime: DatetimeService;

  constructor() {
    const injector = AppInjector.getInjector();
    this.router = injector.get(Router);
    this.toast = injector.get(ToastrService);
    this.storage = injector.get(StorageService);
    this.baseHttp = injector.get(BaseHttpService);
    this.translate = injector.get(TranslateService);
    this.languageService = injector.get(LanguageService);
    this.route = injector.get(ActivatedRoute);
    this.datetime = injector.get(DatetimeService);
  }

  initLangSubscription() {
    const langSub = this.languageService.languageEmitter.subscribe(() => {
      setTimeout(() => location.reload(), 500);
    });
    this.someSubscriptions.add(langSub);
  }

  ngOnDestroy() {
    this.someSubscriptions.unsubscribe();
  }

  authPage(modalName: string = 'login', params?: object) {
    const currentParams = this.route.snapshot.queryParams;
    return {
      ...currentParams,
      ...params,
      auth: modalName,
    };
  }
}
